/* eslint-disable no-empty-pattern */
import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    allAirports: [],
    listOfFlights: [],
    selectedFlight: {},
    bookingData: {},
    allCountries: [],
    multiWayDate: '',
    roundTripDate: '',
    oneWayDate: '',
    flightType: ''
};
const mutations = {
    // set all airports
    SET_ALL_AIRPORTS(state, payload) {
        state.allAirports = payload;
    },
    // set list of flights
    SET_LIST_OF_FLIGHTS(state, payload) {
        state.listOfFlights = payload;
    },
    // set selected flight
    SET_SELECTED_FLIGHT(state, payload) {
        state.selectedFlight = payload;
    },
    SET_BOOKING_DATA(state, bookingData) {
        state.bookingData = bookingData;
    },
    SET_ALL_COUNTRIES(state, data) {
        state.allCountries = data;
    },
    SET_MULTI_WAY_DATE(state, data) {
        state.multiWayDate = data;
    },
    SET_ONE_WAY_DATE(state, data) {
        state.oneWayDate = data;
    },
    SET_ROUND_TRIP_DATE(state, data) {
        state.roundTripDate = data;
    },
    SET_FLIGHT_TYPE(state, data) {
        state.flightType = data;
    },
};
const actions = {
    // get all airports
    async getAllAirports({ commit }, search) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Flight/Airports?PageIndex=0&PageSize=8000&GlobalSearch=${search ? search : ''}&OrderBy=desc&ByDescending=false`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_ALL_AIRPORTS', userParseData.airports);
                return response;
            }
        }
    },
    // get list of flights
    async getListOfFlights({ commit }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Flight/Search`, encryptedData, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_LIST_OF_FLIGHTS', userParseData.flightSearchResponses);
                return response;
            }
        }
    },
    // get selected flight
    async getSelectedFlight({ commit }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Flight/Select`, encryptedData, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_SELECTED_FLIGHT', userParseData);
                return response;
            }
        }
    },
    // book flight
    async bookFlight({ }, payload) {
        const encryptedData = encrypt(payload);
        const response = await this._vm.$http.post(`/Flight/book`, encryptedData, { headers });
        if (response.status === 200) {
            return response;
        }
    },
    // flight ticket
    async payForFlight({ }, payload) {
        const encryptedData = encrypt(payload);
        const response = await this._vm.$http.post(`/Flight/Ticket`, encryptedData, { headers });
        if (response.status === 200) {
            return response;
        }
    },
    async getAllCountries({ commit }) {
        const response = await this._vm.$http.get(`/Flight/Countries/all`, { headers });
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        if (response.status === 200) {
            commit('SET_ALL_COUNTRIES', userParseData);
            return response;
        }
    },
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};